import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }

});
export const figure51 = {
chart: {
zoomType: 'xy',
animation: false,
marginTop: 50,
plotBackgroundColor: null,
plotBorderWidth: null,
plotShadow: false,
type: 'bar',
height: '700px',
backgroundColor: 'rgba(255, 255, 255, 0.0)',
style: {
fontFamily: 'Montserrat'
}
},
colors: ['#fde9fb','#ff3399'],
credits: {
enabled: false
},
title: {
text: null
},
subtitle: {
text: null
},
plotOptions: {
bar: {
dataLabels: {
enabled: true
}
},
series: {
borderWidth: 0,
marker: {
symbol: 'circle',
enabled: false,
states: {
hover: {
enabled: true,
radius: 5
}
}
}
}
},
exporting: {
enabled: false
},
xAxis: [{
tickWidth: 0,
labels: {
groupedOptions: [{
style: {
transform: 'unset'
},
}],
style: {

transform: 'translateX(5px)'
},
align: 'right'
},
categories: [
{
name: "Regiones desarrolladas",
categories: ["Agricultura", "Todos los productos"]
},
{
name: 'Regiones en desarrollo',
categories: ["Agricultura", "Todos los productos"]
},
{
name: "Pequeños Estados insulares en desarrollo (PEID)",
categories: ["Agricultura", "Todos los productos"]
},
{
name: "Países menos adelantados (PMA)",
categories: ["Agricultura", "Todos los productos"]
},
{
name: "Países en desarrollo sin litoral (PDL)",
categories: ["Agricultura", "Todos los productos"]
},
{
name: "Mundo",
categories: ["Agricultura", "Todos los productos"]
},
],
//labels: {
//    style: {
//        align: 'left'
//    },
//},
lineColor: "#d7d7d7",
tickColor: "#d7d7d7",
tickLength: 16,

}],

yAxis: [{
labels: {
style: {
fontWeight: 'normal',
color: '#999999',
fontSize: '12px'
},
},
format: '{value}',
gridLineWidth: 2,

max: 80,
min: 0,
tickInterval: 10,
title: {
text: null,
style: {
color: Highcharts.getOptions().colors[1]
}
}
}],
tooltip: {
shared: true,
useHTML: true,
hideDelay: 500,
backgroundColor: null,
borderWidth: 0,
shadow: false,
valueSuffix: '%',
style: {
padding: 0
}
},
legend: {
enabled: false,
},
series: [{
name: '2015',
dataLabels: {
enabled: false,
formatter: function () {
return Highcharts.numberFormat(this.y, 1);
},
style: {
fontWeight: 'normal',
textOutline: false,
color: '#999999',
fontSize: '10px'
}
},
data: [  47.76753, 55.48501,
62.47953, 73.2048,
69.00908, 73.59023,
72.51035, 72.91599,
50.79914, 55.38741,
45.38508, 55.5663,
],
},
{
name: '2021',
dataLabels: {
enabled: false,
formatter: function () {
return Highcharts.numberFormat(this.y, 1);
},
style: {
fontWeight: 'normal',
textOutline: false,
color: '#999999',
fontSize: '10px'
}
},
data:[ 50.50223, 57.4141,
62.26957, 72.47298,
63.83259, 64.07126,
72.79803, 72.38503,
49.44081, 54.6032,
51.29638, 59.60386, ] 
}
]

}

